var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0.469666L2.53033 2.93934L1.06066 1.46967L0 2.53033L2.53033 5.06066L6.06066 1.53033L5 0.469666ZM5 6.46967L2.53033 8.93933L1.06066 7.46967L0 8.53033L2.53033 11.0607L6.06066 7.53033L5 6.46967ZM2.53033 14.9393L5 12.4697L6.06066 13.5303L2.53033 17.0607L0 14.5303L1.06066 13.4697L2.53033 14.9393ZM19.25 3.74999C19.6642 3.74999 20 3.41421 20 2.99999C20 2.58578 19.6642 2.24999 19.25 2.24999H8.28027C7.86606 2.24999 7.53027 2.58578 7.53027 2.99999C7.53027 3.41421 7.86606 3.74999 8.28027 3.74999H19.25ZM20 8.99999C20 9.41421 19.6642 9.74999 19.25 9.74999H8.28027C7.86606 9.74999 7.53027 9.41421 7.53027 8.99999C7.53027 8.58578 7.86606 8.24999 8.28027 8.24999H19.25C19.6642 8.24999 20 8.58578 20 8.99999ZM19.25 15.75C19.6642 15.75 20 15.4142 20 15C20 14.5858 19.6642 14.25 19.25 14.25H8.28027C7.86606 14.25 7.53027 14.5858 7.53027 15C7.53027 15.4142 7.86606 15.75 8.28027 15.75H19.25Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.0576e8f20616ecbb1563bddaa73353c1.svg";
export { ForwardRef as ReactComponent };